import { getMe } from '../../services/api/me.api';
import { GET_ME_REQUEST, GET_ME_SUCCESS, GET_ME_FAILURE, CLEAR_ME_DATA } from '../types';
import { transformError } from '../../transforms/error';
import { transformMe } from '../../transforms/me';
import { dateFriendly } from '../../helpers/date';
import { USER_ROLE } from '../../enums/user';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: {},
	},

	getters: {
		role: (state) => state.data.role,
		isUser: (state) => {
			return state.data.role === USER_ROLE.USER;
		},
		isAdmin: (state) => {
			return state.data.role === USER_ROLE.ADMIN;
		},
		createdAt: (state) => dateFriendly(state.data.created_at),
		updatedAt: (state) => dateFriendly(state.data.updated_at),
	},

	mutations: {
		[GET_ME_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = {};
		},
		[GET_ME_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformMe(data);
		},
		[GET_ME_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
		[CLEAR_ME_DATA](state) {
			state.data = {};
		},
	},

	actions: {
		async getMe({ commit }) {
			try {
				commit(GET_ME_REQUEST);
				const { data } = await getMe();
				commit(GET_ME_SUCCESS, data);
			} catch (error) {
				commit(GET_ME_FAILURE, error);
			}
		},
		async clear({ commit }) {
			commit(CLEAR_ME_DATA);
		},
	},
};